var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-archive",
    clipPath: "url(#clip0_987_3866)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9199 3.21484L10.0518 0.34375C9.91992 0.211914 9.74121 0.138672 9.55371 0.138672H9.375V3.88867H13.125V3.70996C13.125 3.52539 13.0518 3.34668 12.9199 3.21484ZM5.63672 9.98242C5.1123 9.98242 4.6875 10.3369 4.6875 10.7734C4.6875 11.2129 5.11523 11.5645 5.63965 11.5645C6.16406 11.5645 6.58887 11.21 6.58887 10.7734C6.58887 10.3369 6.16113 9.98242 5.63672 9.98242ZM8.4375 4.12305V0.138672H6.57422V1.07617H5.63672V0.138672H2.57812C2.18848 0.138672 1.875 0.452148 1.875 0.841797V14.4355C1.875 14.8252 2.18848 15.1387 2.57812 15.1387H12.4219C12.8115 15.1387 13.125 14.8252 13.125 14.4355V4.82617H9.14062C8.75391 4.82617 8.4375 4.50977 8.4375 4.12305ZM4.68457 1.07617H5.62207V2.01367H4.68457V1.07617ZM5.63086 12.3262C4.6582 12.3262 3.93164 11.4355 4.125 10.4834L4.69922 7.63867V6.70117H5.63672V5.76367H4.69922V4.82617H5.63672V3.88867H4.69922V2.95117H5.63672V2.01367H6.57422V2.95117H5.63672V3.88867H6.57422V4.82617H5.63672V5.76367H6.57422V6.70117H5.63672V7.63867H6.28418C6.45117 7.63867 6.59766 7.75879 6.62988 7.92285L7.13672 10.4922C7.32422 11.4414 6.59766 12.3262 5.63086 12.3262Z",
    fill: "#524E4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_987_3866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 0.138672)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/Archive.c58cfa8d3ac887a75df77ae6073a2e78.svg";
export { ForwardRef as ReactComponent };